import moment from 'moment'

export const dateMixin = {
  methods: {
    $dateRange (date1, date2) {
      moment.locale('hu')
      if (!date1 && !date2) return ''
      if (!date1) return ` - ${moment(date2).format('LL')}`
      if (!date2) return `${moment(date1).format('LL')} -`
      return `${moment(date1).format('LL')} - ${moment(date2).format('LL')}`
    }
  }
}
